var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center mt-2 mb-2"},[_c('b-spinner')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }